import { ConnectLogoWithText } from '@/components/icons/connect-logo-with-text';

export function ConnectBrandLogo() {
  return (
    <ConnectLogoWithText
      surface="light"
      treatment="color"
      className="shrink-0"
    />
  );
}
